var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1020.31 829.27c-4.64-46.524-13.61-94.5-28.035-143.202-69.39-234.066-281.827-398.23-522.99-408.487V106.715c0-38.008-45.952-57.042-72.828-30.167l-383.96 383.96c-16.66 16.66-16.66 43.675 0 60.335l383.96 383.96c26.875 26.876 72.83 7.842 72.83-30.166v-219.39C565.7 645.6 677.01 669.483 783.923 751.94c59.138 45.61 113.12 107.32 160.65 187.18 22.17 37.25 79.322 21.527 79.322-21.82.01-1.92.01-1.92.05-5.45.28-26.56-.48-50.93-3.636-82.582zM836.033 684.374C702.945 581.73 562.55 555.725 441.705 572.635c-11.7 1.635-20.322 3.35-25.513 4.66-18.95 4.78-32.23 21.825-32.23 41.37V771.64L102.995 490.675 383.96 209.712v110.315c0 24.138 20.01 43.47 44.135 42.638 1.726-.06 3.102-.09 6.66-.152 217.537-4.702 413.795 138.93 475.715 347.8 5.663 19.117 10.385 38.13 14.247 56.97-28.07-31.406-57.676-58.993-88.683-82.907z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackward);
export default __webpack_public_path__ + "static/media/backward.db67827822021495652fcbaf894a4260.svg";
export { ForwardRef as ReactComponent };